import {
	averagePriceConstants
}from './constants'

const initialState =
{
	isSending        : false,
	paged            : {},
	list             : [],
	changed          : null,
	isGetAverageFile : false
}

export default function (state = initialState, action){
	switch (action.type){
		case averagePriceConstants.GetFile.REQUEST:
			return {
				...state,
				isGetAverageFile: true
			}
		case averagePriceConstants.GetFile.SUCCESS:
		case averagePriceConstants.GetFile.FAILURE:
			return {
				...state,
				isGetAverageFile: false
			}
		case averagePriceConstants.Calculation.REQUEST:
		case averagePriceConstants.PreliminaryCalculation.REQUEST:
		case averagePriceConstants.Delete.REQUEST:
		case averagePriceConstants.GetPaged.REQUEST:
		case averagePriceConstants.GetPreliminaryCalculationPaged.REQUEST:
		case averagePriceConstants.GetPreliminaryCalculationFile.REQUEST:
		case averagePriceConstants.PublishPrices.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case averagePriceConstants.Calculation.FAILURE:
		case averagePriceConstants.PreliminaryCalculation.FAILURE:
		case averagePriceConstants.Delete.FAILURE:
		case averagePriceConstants.GetPaged.FAILURE:
		case averagePriceConstants.GetPreliminaryCalculationPaged.FAILURE:
		case averagePriceConstants.GetPreliminaryCalculationFile.FAILURE:
		case averagePriceConstants.PublishPrices.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case averagePriceConstants.GetPaged.SUCCESS:
		case averagePriceConstants.GetPreliminaryCalculationPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case averagePriceConstants.Calculation.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result === true ? "Расчёт средней цены выполнен успешно." : null
			}
		case averagePriceConstants.PreliminaryCalculation.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result === true ? "Предварительный расчёт средней цены выполнен успешно." : null
			}
		case averagePriceConstants.PublishPrices.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result === true ? "Сведения о публикации цен успешно изменены." : null
			}
		case averagePriceConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result === true ? "Сведения о расчёте средних цен успешно удалены." : null
			}
		case averagePriceConstants.GetPreliminaryCalculationFile.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case averagePriceConstants.CLEAR:
			return {
				...state,
				changed          : null,
				isSending        : false,
				paged            : {},
				list             : [],
				isGetAverageFile : false
			}
		case averagePriceConstants.CLEAR_MESSAGE:
			return {
				...state,
				changed: null
			}
		default:
			return state
	}
}